import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
    display: flex;
    height: 300px;
    padding: 10px;
    flex-direction: column;
`;

export const Title = lib.styled.span`
  font-size: 15px;
  font-weight: bold;
  opacity: 0.5;
`;

export const Row = lib.styled.div`
  display: flex;
  justify-content: space-between;
  max-height: 45px;
  border: 1px dotted ${colors.lightGray06};
  border-radius: 10px;
  background-color: ${colors.white02};
  padding: 10px;
`;

export const Body = lib.styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  gap: 5px;
  margin-top: 10px;
`;

export const Banner = lib.styled.div`
  display: flex;
  background: ${colors.lightBlue06};
  border-radius: 18px;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 12px;
  min-height: 45px;
  align-items: center;
  justify-content: center;
  padding: 0 10px 0 10px;
`;
